import React from 'react';
import { AvatarImageStackWrapper, AvatarImageStyled } from './avatar-image-stack.component.style';
export const AvatarImageStack = (props) => {
    var _a;
    return (React.createElement(AvatarImageStackWrapper, null, (_a = props.authors) === null || _a === void 0 ? void 0 : _a.map((assignee, index) => (React.createElement(AvatarImageStyled, { key: `${assignee.id}_${props.bookingId}_${index}`, src: assignee.avatarUrl })))));
};
